import useWaitForAutomation from './use-wait-for-automation';

export default {
  useWaitForAutomation,
};
